import React, {useContext, useEffect, useState} from 'react';
import { generatePopupContent } from '../healper';
import {authContext} from '../../Context/Authentication/authContext';
import './Map.scss'


const LAT_LNG = {
  florida: {
    lat: 27.994402,
    lng: -81.760254
  },
  texas: {
    lat: 31.00,
    lng: -100.00
  },
  california: {
    lat: 36.778259,
    lng: -119.417931
  },
  tennessee: {
    lat: 35.860119,
    lng: -86.660156
  }
}

declare const google: any;

const WareHouseMap = (props: any) => {
  const {state}: any = useContext(authContext);
  let mapMarkers: any[] = []
  let popup: any = null
  const listeners: any[] = []
  const selectedState = state.filters.state.toLowerCase()
  // @ts-ignore
  const stateCord = LAT_LNG[selectedState]

  useEffect(() => {
    const { mapData, geoData, markers, colors } = props;

    const removeGeoLocations = (map: any) => {
      map.data.forEach(function (feature: any) {
        map.data.remove(feature);
      });
    }

    const removeListeners = () => {
      listeners.forEach((listener: any) => {
        listener.remove()
      })
    }

    const removeMarkers = () => {
      mapMarkers.forEach((marker: any) => {
        marker.setMap(null)
      })
    }

    const drawMarkers = (markersData: any, popupInfo: any) => {
      markersData.forEach((marker: any) => {
        const url = `http://maps.google.com/mapfiles/ms/icons/${marker.className}.png`
        const markerInfo = new google.maps.Marker({
          position: marker.position,
          draggable: false,
          label: {
            text: marker.cluster.toString(),
            className: 'map-label-text'
          },
          icon: {
            url,
            scaledSize: new google.maps.Size(40, 40),
          }
        })
        const listener = markerInfo.addListener('click', () => {
          popupInfo.setContent(generatePopupContent(marker, true))
          popupInfo.setPosition(marker.position)
          popupInfo.open(map)
        });
        listeners.push(listener)
        markerInfo.setAnimation(google.maps.Animation.DROP);
        mapMarkers.push(markerInfo)
      })
    }

    const displayMarkers = (map: any) => {
      mapMarkers.forEach((marker: any) => {
        marker.setMap(map)
      })
    }

    const map = new google.maps.Map(document.getElementById('warehouseMap'), {
      zoom: 6.5,
      mapTypeIds: [google.maps.MapTypeId.HYBRID, 'Grayscale'],
      center: new google.maps.LatLng(
        stateCord?.lat && stateCord.lng ? stateCord.lat : 25.7617,
        stateCord?.lat && stateCord.lng ? stateCord.lng : -80.496929
      ),
      mapTypeControl: false,
      streetViewControl: false,
    });

    const drawMap = () => {
      removeMarkers()
      removeGeoLocations(map)
      removeListeners()
      if (popup) popup.close()
      popup = null

      mapData.forEach((mapInfo: any) => {
        const properties = {
          warehouseZipcodeId: mapInfo.Warehouse_zip_code_id,
          pref: mapInfo.pref,
          zipcode: mapInfo['zip code'],
          investment: `$ ${mapInfo['investment($)']}`,
          expectedProfit: `$ ${mapInfo['expected_profit($)']}`,
          expectedPercentage: `${mapInfo.expected_percent_of_retrns_per_month}%`,
          expectedTruckLoad: mapInfo.expected_truck_loads_transport_per_month,
          coveredHousehold: mapInfo.covered_house_holds,
          coveredZipcode: mapInfo.covered_no_of_zip_codes,
          fill: colors[mapInfo.Warehouse_zip_code_id - 1],
        };

        if (Object.keys(geoData).length) {
          mapInfo.covered_zip_codes.forEach((zip: any) => {
            const poly = geoData[zip];
            if (poly) {
              poly.properties = { ...poly.properties, ...properties };
              map.data.addGeoJson(poly, `zip-${zip}`);
            }
          });
        }
      });

      map.data.setStyle((feature: { getProperty: (arg0: string) => any }) => {
        return {
          // @ts-ignore
          fillColor: feature.getProperty('fill'),
          strokeWeight: 1,
          fillOpacity: 0.7,
        };
      });

      popup = new google.maps.InfoWindow()

      const listener = map.data.addListener('click', (event: { latLng: any; }) => {
        const htmlContent = generatePopupContent(event, false)
        popup.setContent(htmlContent)
        popup.setPosition(event.latLng)
        popup.open(map)
      })
      listeners.push(listener)
      drawMarkers(markers, popup)
      displayMarkers(map)

      const popupListener = google.maps.event.addListener(map, 'click', function () {
        popup.close()
      });
      listeners.push(popupListener)
    }

    drawMap()

  }, [])

  return <div id='warehouseMap'/>;
};

export default WareHouseMap;
